@if (device$ | async; as device) {
  <div class="d-flex align-items-center justify-content-between mb-2">
    <span>Tuning mode</span>
    @if (
      (positionControlStrategyParameter$ | async)?.value === 2 &&
      (hasEncoderConfigurationUsedForVelocity$ | async) === true
    ) {
      <div class="btn-group">
        <input
          class="btn-check"
          type="radio"
          name="automaticTuningMode"
          id="automaticTuningMode"
          [checked]="tuningController.autoTuningEnabled"
          [value]="true"
          [disabled]="isFullAutotuningRunning"
          (click)="onSetAutoTuningEnabled(true)"
        />
        <label
          class="btn"
          [ngClass]="tuningController.autoTuningEnabled ? 'btn-secondary' : 'btn-outline-secondary'"
          for="automaticTuningMode"
          >Automatic</label
        >
        <input
          class="btn-check"
          type="radio"
          name="automaticTuningMode"
          id="manualTuningMode"
          [checked]="!tuningController.autoTuningEnabled"
          [value]="false"
          [disabled]="isFullAutotuningRunning"
          (click)="onSetAutoTuningEnabled(false)"
        />
        <label
          class="btn"
          [ngClass]="tuningController.autoTuningEnabled ? 'btn-outline-secondary' : 'btn-secondary'"
          for="manualTuningMode"
          >Manual</label
        >
      </div>
    }
  </div>
  @if (hasEncoderConfigurationUsedForVelocity$ | async) {
    <div class="mb-2">
      <app-device-parameter-form
        [parameters$]="positionControlStrategyParameters$"
        [disableInputs]="isFullAutotuningRunning"
      ></app-device-parameter-form>
    </div>
  }
  @if ((hasEncoderConfigurationUsedForVelocity$ | async) === false) {
    <div class="alert alert-warning" role="alert">
      <i class="bi-exclamation-triangle-fill me-1"></i>
      There is no encoder configured with velocity function. Showing only the simple PID tuning.
    </div>
  }
  @if (
    (positionControlStrategyParameter$ | async)?.value === 1 ||
    (hasEncoderConfigurationUsedForVelocity$ | async) === false
  ) {
    <div>
      <app-device-parameter-form
        [parameters$]="simplePidParameters$"
        [showApplyButton]="true"
        [showSubmit]="true"
        [disableInputs]="isFullAutotuningRunning"
        submitText="APPLY PID VALUES"
      >
      </app-device-parameter-form>
    </div>
  } @else {
    @if (tuningController.autoTuningEnabled) {
      <div>
        <app-parameter-form
          [parameters$]="cascadedControllerConfigurationParameters$"
          [showApplyButton]="false"
          [disableInputs]="isFullAutotuningRunning"
          (selectChange)="onTuningControllerParametersControlSelectChange($event)"
          (rangeInputChange)="onTuningParametersControlRangeInputChange($event)"
          (formSubmit)="onTuningParametersFormSubmit($event)"
        >
        </app-parameter-form>
        @if (gainSchedulingEnabled$ | async) {
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="my-3">GAIN SCHEDULING IS ENABLED</h5>
            <div>
              <button type="button" class="btn btn-sm btn-light" (click)="onOpenQuickOpenModal('#gainScheduling')">
                <i class="bi-pencil-fill"></i>
              </button>
            </div>
          </div>
          @if (gainSchedulingParametersOverview$ | async; as data) {
            <table
              class="table table-sm mb-0 mt-2"
              [ngClass]="{
                'opacity-50': isFullAutotuningRunning
              }"
            >
              <colgroup>
                <col style="width: 34%" />
                <col style="width: 33%" />
                <col style="width: 33%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">&nbsp;</th>
                  <th scope="col">POSITION</th>
                  <th scope="col">VELOCITY</th>
                </tr>
              </thead>
              <tbody>
                @for (item of data; track $index) {
                  <tr>
                    <td scope="row" colspan="3" class="bg-dark-subtle">
                      <div class="d-flex justify-content-between">
                        <span class="fw-bold">{{ item.threshold.name }}</span>
                        <span>{{ item.threshold.value }} {{ item.threshold | parameterUnitDisplay }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Kp</td>
                    <td>{{ item.parameters[0][0].value | roundFloat: 6 }}</td>
                    <td>{{ item.parameters[1][0].value | roundFloat: 6 }}</td>
                  </tr>
                  <tr>
                    <td>Ki</td>
                    <td>{{ item.parameters[0][1].value | roundFloat: 6 }}</td>
                    <td>{{ item.parameters[1][1].value | roundFloat: 6 }}</td>
                  </tr>
                  <tr>
                    <td>Kd</td>
                    <td>{{ item.parameters[0][2].value | roundFloat: 6 }}</td>
                    <td>{{ item.parameters[1][2].value | roundFloat: 6 }}</td>
                  </tr>
                  <tr>
                    <td scope="row">Int. limit</td>
                    <td>{{ item.parameters[0][3].value }}</td>
                    <td>{{ item.parameters[1][3].value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        } @else {
          <div class="d-flex align-items-center mb-3">
            <div class="w-100">
              <app-full-auto-tuning-button
                [device]="device$ | async"
                (startFullAutoTuning)="onStartFullAutoTuning()"
              ></app-full-auto-tuning-button>
            </div>
            <button
              class="btn btn-outline-link rounded-0 border-top-0 border-end-0 border-bottom-0 btn-parameter-help text-body-secondary pt-3"
              type="button"
              tabindex="-1"
              title="Open description"
              (click)="onOpenFullAutoTuningDescription()"
            >
              <i class="bi-info-circle"></i>
            </button>
          </div>
          <app-parameter-form
            [parameters$]="restTuningParameters$"
            [showApplyButton]="false"
            [disableInputs]="isFullAutotuningRunning"
            (selectChange)="onTuningControllerParametersControlSelectChange($event)"
            (rangeInputChange)="onTuningParametersControlRangeInputChange($event)"
            (formSubmit)="onTuningParametersFormSubmit($event)"
          >
          </app-parameter-form>
          <table
            class="table table-sm mb-0 mt-2"
            [ngClass]="{
              'opacity-50': isFullAutotuningRunning
            }"
          >
            <colgroup>
              <col style="width: 34%" />
              <col style="width: 33%" />
              <col style="width: 33%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" style="width: 34%">&nbsp;</th>
                <th scope="col" style="width: 33%">POSITION</th>
                <th scope="col" style="width: 33%">VELOCITY</th>
              </tr>
            </thead>
            @if (cascadedPidParametersOverview$ | async; as parameters) {
              <tbody>
                <tr>
                  <th scope="row">Kp</th>
                  <td>{{ parameters[0][0].value | roundFloat: 6 }}</td>
                  <td>{{ parameters[1][0].value | roundFloat: 6 }}</td>
                </tr>
                <tr>
                  <th scope="row">Ki</th>
                  <td>{{ parameters[0][1].value | roundFloat: 6 }}</td>
                  <td>{{ parameters[1][1].value | roundFloat: 6 }}</td>
                </tr>
                <tr>
                  <th scope="row">Int. limit</th>
                  <td>{{ parameters[0][3].value }}</td>
                  <td>{{ parameters[1][3].value }}</td>
                </tr>
              </tbody>
            }
          </table>
        }
      </div>
    } @else {
      <app-device-parameter-form
        [parameters$]="cascadedPidParameters$"
        [showApplyButton]="true"
        [showSubmit]="true"
        [disableInputs]="isFullAutotuningRunning"
        submitText="APPLY PID VALUES"
      >
      </app-device-parameter-form>
    }
  }
}
